import { useState } from 'react';
import { billingApi } from '../api/billing.api';
import { useNotify } from '../context/NotifyContext';

/**
 * Downloads a tax invoice as a PDF, shared by the billing list, the invoice page
 * and the post-payment screen. `downloadingId` is the invoice currently being
 * fetched, so a list can disable just the row that was clicked.
 */
export function useInvoiceDownload() {
  const { notify } = useNotify();
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const download = async (invoiceId: string, invoiceNumber: string) => {
    setDownloadingId(invoiceId);
    try {
      await billingApi.downloadInvoicePdf(invoiceId, invoiceNumber);
    } catch {
      // The request asks for a blob, so a failure body arrives as a Blob rather
      // than the usual parsed { message } — hence a fixed message here.
      notify.error('Could not download the invoice. Please try again.');
    } finally {
      setDownloadingId(null);
    }
  };

  return { download, downloadingId };
}

export default useInvoiceDownload;
